import { handleActions } from "redux-actions";
import { push } from "react-router-redux";
import { initialize as initializeForm } from "redux-form";
import Swal from "sweetalert2";
import { api } from "api";

const LOADER = "GASTOS_ADMINISTRATIVOS_LOADER";
const LOADER_EDITAR = "GASTOS_ADMINISTRATIVOS_LOADER_EDITAR";
const DATA = "GASTOS_ADMINISTRATIVOS_DATA";
const SUBMIT = "GASTOS_ADMINISTRATIVOS_SUBMIT";
const FILTER = "GASTOS_ADMINISTRATIVOS_FILTER";

const ENDPOINT = "gastos_administrativos";

export const constants = {
    SUBMIT,
};

// ------------------------------------
// Pure Actions
// ------------------------------------

export const setLoader = (loader) => ({
    type: LOADER,
    loader,
});

export const setData = (data) => ({
    type: DATA,
    data,
});

export const setLoaderEditar = (loaderEditar) => ({
    type: LOADER_EDITAR,
    loaderEditar,
});

export const setFilter = (filter) => ({
    type: FILTER,
    filter,
});

// ------------------------------------
// Actions
// ------------------------------------
export const onSubmit =
    (data = {}) =>
    (dispatch, getStore) => {
        dispatch(setLoaderEditar(true));
        api.post(`${ENDPOINT}`, data)
            .then(() => {
                Swal.fire({
                    title: "Éxito",
                    text: "Se ha guardado correctamente",
                    type: "success",
                    showConfirmButton: false,
                    timer: 500,
                });
                dispatch(push("/gastos_administrativos"));
            })
            .catch((error) => {
                const textError =
                    error && error.nombre
                        ? "\nEste país ya existe"
                        : "Ha ocurrido un error, inténtelo nuevamente.";
                Swal.fire({
                    title: "Error",
                    text: textError,
                    type: "error",
                });
            })
            .finally(() => {
                dispatch(setLoaderEditar(false));
            });
    };

export const listar =
    (page = 1, params = {}) =>
    (dispatch) => {
        dispatch(setLoader(true));
        api.get(`${ENDPOINT}`, { page, ...params })
            .then((response) => {
                dispatch(setData(response));
            })
            .catch(() => {})
            .finally(() => {
                dispatch(setLoader(false));
            });
    };

export const obtenerGastosAdministrativos =
    (id = null) =>
    (dispatch) => {
        dispatch(setLoaderEditar(true));
        api.get(`${ENDPOINT}/${id}`)
            .then((response) => {
                dispatch(initializeForm("CrearEditarForm", response));
            })
            .catch(() => {})
            .finally(() => {
                dispatch(setLoaderEditar(false));
            });
    };

export const actualizarGastosAdministrativos =
    (data = {}, id = null) =>
    (dispatch) => {
        dispatch(setLoaderEditar(true));
        api.put(`${ENDPOINT}/${id}`, data)
            .then(() => {
                Swal.fire({
                    title: "Éxito",
                    text: "Se ha actualizado correctamente",
                    type: "success",
                    showConfirmButton: false,
                    timer: 500,
                });
                dispatch(push("/gastos_administrativos"));
            })
            .catch((error) => {
                const textError =
                    error && error.nombre
                        ? "\nEste país ya existe"
                        : "Ha ocurrido un error, inténtelo nuevamente.";
                Swal.fire({
                    title: "Error",
                    text: textError,
                    type: "error",
                });
            })
            .finally(() => {
                dispatch(setLoaderEditar(false));
            });
    };

export const eliminar = (id) => (dispatch) => {
    dispatch(setLoader(true));
    api.eliminar(`${ENDPOINT}/${id}`)
        .then(() => {
            Swal.fire({
                title: "Éxito",
                text: "Se ha eliminado correctamente",
                type: "success",
            });
        })
        .catch(() => {})
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const obtenerFilterList = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get(`${ENDPOINT}/filter_list`)
        .then((response) => {
            dispatch(setFilter(response));
        })
        .catch(() => {})
        .finally(() => {
            dispatch(setLoader(false));
        });
};

export const actions = {
    onSubmit,
    eliminar,
    obtenerGastosAdministrativos,
    actualizarGastosAdministrativos,
    listar,
    obtenerFilterList,
};

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [LOADER_EDITAR]: (state, { loaderEditar }) => {
        return {
            ...state,
            loaderEditar,
        };
    },
    [DATA]: (state, { data }) => {
        return {
            ...state,
            data,
        };
    },
    [FILTER]: (state, { filter }) => {
        return {
            ...state,
            filter,
        };
    },
};

export const initialState = {
    loader: false,
    loaderEditar: false,
    data: {},
    filter: [],
};

export default handleActions(reducers, initialState);
